import React from 'react';
import {
  Navigate,
  Outlet,
  useOutletContext,
  useParams,
} from 'react-router-dom';
import { routes } from 'containers/routes';
import { Schoolyear } from 'types/schoolyear';
import SpinnerComponent from 'components/Spinner/ScreenSpinner';

export function SchoolDataProvider() {
  const { schoolId } = useParams<{
    schoolId: string;
  }>();
  const { schoolyear, isSchoolyearFetching } = useOutletContext<{
    schoolyear: Schoolyear;
    isSchoolyearFetching?: boolean;
  }>();

  const matchingSchool = (schoolyear?.schools || []).find(
    s => s.id === schoolId,
  );

  if (!matchingSchool) {
    if (isSchoolyearFetching) {
      return <SpinnerComponent />;
    }
    return (
      <Navigate
        to={routes.schoolyearSettings({
          schoolyearId: schoolyear.id,
        })}
      />
    );
  }

  return (
    <Outlet
      context={{
        schoolyear,
        school: matchingSchool,
      }}
    />
  );
}
